import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  isDevMode,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { provideTransloco } from '@jsverse/transloco';
import { routes } from './app.routes';
import { TranslocoHttpLoader } from './transloco-loader';
import { serviceApiInterceptor } from './interceptors/service.interceptor';
import { environment } from './environments/environment';
import { Configuration as CatalogoConfig } from './api/catalogo/configuration';
import { Configuration as PrenotazioneConfig } from './api/prenotazione/configuration';
import { Configuration as IndirizzoConfig } from './api/indirizzo/configuration';
import { Configuration as MobileAppBeConfig } from './api/mobile-app-be/configuration';
import { Configuration as AnaWikiConfig } from './api/ana-wiki/configuration';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([serviceApiInterceptor])),
    provideTransloco({
      config: {
        availableLangs: ['it', 'en'],
        defaultLang: 'it',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    {
      provide: CatalogoConfig,
      useValue: new CatalogoConfig({ basePath: environment.catalogoApiUrl })
    },
    {
      provide: PrenotazioneConfig,
      useValue: new PrenotazioneConfig({ basePath: environment.prenotazioneApiUrl })
    },
    {
      provide: IndirizzoConfig,
      useValue: new IndirizzoConfig({ basePath: environment.indirizzoApiUrl })
    },
    {
      provide: MobileAppBeConfig,
      useValue: new MobileAppBeConfig({ basePath: environment.mobileAppBeApiUrl })
    },
    {
      provide: AnaWikiConfig,
      useValue: new AnaWikiConfig({ basePath: environment.anaWikiApiUrl })
    },
  ],
};
